import { SelectOption } from "../../../../../../shared/interfaces";

export function buildInsuredTable(
  title: string,
  insuredList: any[],
  apActiviesListOptions: SelectOption[]
) {
  if (!insuredList || insuredList.length === 0) return "";
  return `
    <h3>${title}</h3>
    <table border="1" cellpadding="4" cellspacing="0" style="border-collapse: collapse; font-family: Arial, sans-serif; width: 100%; max-width: 800px;">
      <thead style="background: #eee;">
        <tr>
          <th>Nombre</th>
          <th>CUIL</th>
          <th>Documento</th>
          <th>Fecha Nacimiento</th>
          <th>Sexo</th>
          <th>Actividad</th>
        </tr>
      </thead>
      <tbody>
        ${insuredList
          .map(
            (insured) => `
          <tr>
            <td>${insured.integrante ?? ""}</td>
            <td>${insured.nroCuilVida ?? ""}</td>
            <td>${insured.tipoDocumento || ""} ${
              insured.numeroDocumento || ""
            }</td>
            <td>${insured.fechaNacimiento ?? ""}</td>
            <td>${insured.sexo ?? ""}</td>
            <td>${
              apActiviesListOptions.find((e) => e.value === insured.actividad)
                ?.label ?? ""
            }</td>
          </tr>
        `
          )
          .join("")}
      </tbody>
    </table>
  `;
}